<div
	class="analytics-report-access-gate__shell"
	[attr.data-testid]="testId() ?? 'report-access-gate'"
>
	<div class="analytics-report-access-gate__layout">
		<!-- Client title above — 20px gap to card via layout; omit when unset -->
		@if (brandName() || brandLogoUrl()) {
			<header class="analytics-report-access-gate__brand">
				@if (brandLogoUrl()) {
					<img
						class="analytics-report-access-gate__brand-logo"
						[src]="brandLogoUrl()"
						[alt]="brandName() || ''"
						width="40"
						height="40"
					/>
				} @else if (brandName()) {
					<span
						class="analytics-report-access-gate__brand-logo analytics-report-access-gate__brand-logo--initials"
						aria-hidden="true"
					>{{ brandName() | jepInitials }}</span>
				}
				@if (brandName()) {
					<span class="analytics-report-access-gate__brand-name">{{
						brandName()
					}}</span>
				}
			</header>
		}

		<div
			class="analytics-report-access-gate__card"
			[class.analytics-report-access-gate__card--code]="step() === 'code'"
		>
			@switch (step()) {
				@case ('denied') {
					<div class="analytics-report-access-gate__heading">
						<span
							class="analytics-report-access-gate__heading-icon icon-lock"
							aria-hidden="true"
						></span>
						<div class="analytics-report-access-gate__heading-copy">
							<h1 class="analytics-report-access-gate__title">
								Report unavailable
							</h1>
							<p class="analytics-report-access-gate__subtitle">
								{{ genericDenial }}
							</p>
						</div>
					</div>
				}

				@case ('requested') {
					<div class="analytics-report-access-gate__heading">
						<span
							class="analytics-report-access-gate__heading-icon material-symbols-outlined"
							aria-hidden="true"
							>mark_email_read</span
						>
						<div class="analytics-report-access-gate__heading-copy">
							<h1 class="analytics-report-access-gate__title">
								Request sent
							</h1>
							<div
								class="analytics-report-access-gate__subtitle analytics-report-access-gate__subtitle--requested"
							>
								<p>
									We've let the report owner know you'd like
									access.
								</p>
								<p>
									You can close this page, there's nothing
									more to do right now.
								</p>
							</div>
						</div>
					</div>
					<button
						type="button"
						class="analytics-report-access-gate__back"
						[disabled]="busy()"
						(click)="onStartOver()"
					>
						<span
							class="analytics-report-access-gate__back-icon icon-arrow-left"
							aria-hidden="true"
						></span>
						<span class="analytics-report-access-gate__back-label"
							>Use a different email</span
						>
					</button>
				}

				@case ('request') {
					<div class="analytics-report-access-gate__request-panel">
						<div class="analytics-report-access-gate__code-intro">
							<button
								type="button"
								class="analytics-report-access-gate__back"
								[disabled]="busy()"
								(click)="onStartOver()"
							>
								<span
									class="analytics-report-access-gate__back-icon icon-arrow-left"
									aria-hidden="true"
								></span>
								<span class="analytics-report-access-gate__back-label"
									>Back</span
								>
							</button>

							<div class="analytics-report-access-gate__code-copy">
								<h1 class="analytics-report-access-gate__title">
									Ask for Access
								</h1>
								<div
									class="analytics-report-access-gate__subtitle analytics-report-access-gate__subtitle--code"
								>
									<p>
										That email hasn't been granted
										permission to view the report yet.
									</p>
									<p>
										You can request permission from the
										report owner for access below.
									</p>
								</div>
							</div>
						</div>

						<jepto-ui-input
							class="analytics-report-access-gate__input"
							label="Email address"
							placeholder="you@company.com"
							type="email"
							appearance="fill"
							prefixIcon="mail"
							autocomplete="email"
							inputId="gate-request-email-input"
							testId="gate-request-email-input"
							[showClearButton]="true"
							[disabled]="busy()"
							[ngModel]="email()"
							(ngModelChange)="email.set($event)"
						/>

						<label class="analytics-report-access-gate__note-field">
							<span
								class="analytics-report-access-gate__note-label"
								>Note (Optional)</span
							>
							<textarea
								class="analytics-report-access-gate__note-input"
								rows="2"
								placeholder=""
								[disabled]="busy()"
								[ngModel]="requestNote()"
								(ngModelChange)="requestNote.set($event)"
								data-testid="gate-request-note-input"
							></textarea>
						</label>

						<jepto-button
							class="analytics-report-access-gate__primary-button"
							text="Request Access"
							type="analysis"
							size="medium"
							buttonType="button"
							testId="gate-request-access-button"
							width="100%"
							[isLoading]="busy()"
							[disabled]="busy()"
							(isClicked)="onRequestAccess()"
						/>

						@if (errorMessage()) {
							<p
								class="analytics-report-access-gate__error"
								data-testid="gate-error"
							>
								{{ errorMessage() }}
							</p>
						}
					</div>
				}

				@case ('code') {
					<div class="analytics-report-access-gate__code-panel">
						<div class="analytics-report-access-gate__code-body">
							<div class="analytics-report-access-gate__code-intro">
								<button
									type="button"
									class="analytics-report-access-gate__back"
									[disabled]="busy()"
									(click)="onStartOver()"
								>
									<span
										class="analytics-report-access-gate__back-icon icon-arrow-left"
										aria-hidden="true"
									></span>
									<span class="analytics-report-access-gate__back-label"
										>Back</span
									>
								</button>

								<div class="analytics-report-access-gate__code-copy">
									<h1 class="analytics-report-access-gate__title">
										Enter your code
									</h1>
									<div
										class="analytics-report-access-gate__subtitle analytics-report-access-gate__subtitle--code"
									>
										@if (email()) {
											<p>
												We sent a 6-digit code to
												<strong>{{ email() }}</strong>.
											</p>
										} @else {
											<p>
												Enter the 6-digit code from your
												email.
											</p>
										}
										<p>
											Enter it below, or just tap the link
											in that email.
										</p>
									</div>
								</div>
							</div>

							<div
								class="analytics-report-access-gate__otp"
								(paste)="onOtpPaste($event)"
							>
								@for (
									digit of otpDigits();
									track $index;
									let index = $index
								) {
									<input
										#otpCell
										class="analytics-report-access-gate__otp-cell"
										[class.analytics-report-access-gate__otp-cell--active]="
											isOtpCellActive(index)
										"
										[class.analytics-report-access-gate__otp-cell--compact]="
											index < 2
										"
										type="text"
										inputmode="numeric"
										pattern="[0-9]*"
										maxlength="1"
										autocomplete="one-time-code"
										[attr.data-testid]="
											'gate-otp-cell-' + index
										"
										[attr.aria-label]="
											'Digit ' + (index + 1) + ' of 6'
										"
										[disabled]="busy()"
										[value]="digit"
										(focus)="onOtpFocus(index)"
										(blur)="onOtpBlur()"
										(input)="onOtpInput(index, $event)"
										(keydown)="onOtpKeydown(index, $event)"
									/>
								}
							</div>

							@if (busy()) {
								<div
									class="analytics-report-access-gate__checking"
									role="status"
									aria-live="polite"
									data-testid="gate-checking-code"
								>
									<span
										class="analytics-report-access-gate__checking-spinner"
										aria-hidden="true"
									></span>
									<p class="analytics-report-access-gate__checking-label">
										Checking your code…
									</p>
								</div>
							} @else if (errorMessage()) {
								<p
									class="analytics-report-access-gate__error"
									data-testid="gate-error"
								>
									{{ errorMessage() }}
								</p>
							}
						</div>

						<div class="analytics-report-access-gate__code-footer">
							<p class="analytics-report-access-gate__code-footer-hint">
								Didn't get it? Check spam.
							</p>
							<button
								type="button"
								class="analytics-report-access-gate__code-footer-action"
								[disabled]="busy()"
								(click)="onResendCode()"
							>
								Resend Code
							</button>
						</div>
					</div>
				}

				@default {
					<div class="analytics-report-access-gate__heading">
						<span
							class="analytics-report-access-gate__heading-icon icon-lock"
							aria-hidden="true"
						></span>
						<div class="analytics-report-access-gate__heading-copy">
							<h1 class="analytics-report-access-gate__title">
								This report is restricted
							</h1>
							<p class="analytics-report-access-gate__subtitle">
								Enter your email and we'll send you a one-time
								code to open the report.
							</p>
						</div>
					</div>

					<jepto-ui-input
						class="analytics-report-access-gate__input"
						label="Email address"
						placeholder="you@company.com"
						type="email"
						appearance="fill"
						prefixIcon="mail"
						autocomplete="email"
						inputId="gate-email-input"
						testId="gate-email-input"
						[showClearButton]="true"
						[disabled]="busy()"
						[ngModel]="email()"
						(ngModelChange)="email.set($event)"
						(enterPressed)="onSendCode()"
					/>

					<div class="analytics-report-access-gate__actions">
						<jepto-button
							class="analytics-report-access-gate__primary-button"
							text="Send me a code"
							type="analysis"
							size="medium"
							buttonType="button"
							testId="gate-send-code-button"
							width="100%"
							[isLoading]="busy()"
							[disabled]="busy()"
							(isClicked)="onSendCode()"
						/>
						<p class="analytics-report-access-gate__helper">
							We send a code so there is no need to remember
							passwords.
						</p>
						<button
							type="button"
							class="analytics-report-access-gate__text-link"
							[disabled]="busy()"
							(click)="onAlreadyHaveCode()"
						>
							Already got a code
						</button>
					</div>
				}
			}

			@if (errorMessage() && step() !== 'code' && step() !== 'request') {
				<p
					class="analytics-report-access-gate__error"
					data-testid="gate-error"
				>
					{{ errorMessage() }}
				</p>
			}
		</div>
	</div>

	@if (showThemeSwitcher()) {
		<div class="analytics-report-access-gate__theme-switcher">
			<jepto-theme-switcher />
		</div>
	}
</div>
